import React, { useState } from 'react'
import { sendPasswordResetEmail } from 'firebase/auth'
import { useNavigate } from 'react-router-dom'
import { auth, functions, ENV_SUFFIX } from '../../firebase'
import { httpsCallable } from 'firebase/functions'
import TextField from '../Form/TextField'
import Button from '../Button'
import { toast } from 'react-hot-toast'

export default function ForgotPassword() {
  const navigate = useNavigate()
  const [resetEmail, setResetEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const getActionUrl = () => {
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:3000/reset-password'
    } else {
      return 'https://livealarm.app/reset-password'
    }
  }

  async function handleForgotPassword(e) {
    e.preventDefault()

    if (!resetEmail) {
      toast.error('Please enter your email address.')
      return
    }

    setIsLoading(true)

    const actionCodeSettings = {
      url: getActionUrl()
    }

    try {
      const email = resetEmail.toLowerCase().trim()

      // Use the same Cloud Function as Login component
      const getUserByEmailFn = httpsCallable(
        functions,
        `getUserByEmail${ENV_SUFFIX}`
      )
      const response = await getUserByEmailFn({ email })

      const userData = response.data

      // Check if user exists and is not admin
      if (!userData) {
        toast.error('No account found with this email address.')
        return
      }

      if (userData.isAdmin === true) {
        toast.error('No account found with this email address.')
        return
      }

      // If user exists and is not admin, send reset email
      await sendPasswordResetEmail(auth, email, actionCodeSettings)
      toast.success(
        'A password reset email has been sent to your registered email address. Please check your inbox.'
      )
      setResetEmail('')
    } catch (err) {
      // Not-found covers both "no such address" and "an administrator
      // account", which this screen deliberately shows identically.
      if (err.code === 'functions/not-found') {
        toast.error('No account found with this email address.')
      } else {
        toast.error(err.message)
      }
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='login-container'>
      <div className='login-grid'>
        <div className='login-left login-centered'>
          <div className='login-form'>
            <div className='login-logo'>
              <img
                className='login'
                src='/assets/images/live-alarm.png'
                alt='forgot password visual'
              />
            </div>
            <form onSubmit={handleForgotPassword}>
              <div className='login-input mb-4'>
                <TextField
                  label='Email'
                  name='resetEmail'
                  type='email'
                  value={resetEmail}
                  onChange={(e) => setResetEmail(e.target.value)}
                  required={true}
                  autoComplete='off'
                  placeholder='Email'
                />
              </div>

              <Button
                type='submit'
                className='login-button'
                disabled={isLoading}>
                {isLoading ? 'Sending...' : 'Send Password Reset Link'}
              </Button>

              <div className='login-signup'>
                <a
                  href='/login'
                  className='login-forgot'
                  style={{ textDecoration: 'none' }}>
                  <strong>Back to Login</strong>
                </a>
              </div>
            </form>
          </div>
        </div>
        <div className='login-right login-centered login-overflow'>
          <img
            className='login-image'
            src='/assets/images/logo.png'
            alt='forgot password visual'
          />
        </div>
      </div>
    </div>
  )
}
